import React from 'react';
import { Field } from 'react-final-form';
import classNames from 'classnames';

import AutocompleteSelect from '../AutocompleteSelect/AutocompleteSelect';

import css from './FieldAutocompleteSelect.css';

const FieldAutocompleteSelectComponent = props => {
  const {
    rootClassName,
    className,
    id = null,
    label = null,
    placeholder = null,
    inputValue,
    onChange,
    meta,
    markRequired,
    options,
    disabled,
    textRequired,
    validate,
    input,
    requiredProvider,
    onInputChange,
    isLoading,
    ...rest
  } = props;

  const { value = {value: '', label: ''}, ...inputProps } = input;

  if (label && !id) {
    throw new Error('id required when a label is given');
  }

  const { invalid, touched, error } = meta;
  const hasError = touched && invalid && error;

  const classes = classNames(rootClassName || css.root, className);
  return (
    <div className={classes}>
      <AutocompleteSelect
        inputValue={inputValue}
        onChange={onChange}
        id={id}
        label={label}
        error={hasError && requiredProvider}
        markRequired={markRequired}
        placeholder={placeholder}
        options={options}
        disabled={disabled}
        onInputChange={onInputChange}
        isLoading={isLoading}
        {...inputProps}
      />
    </div>
  );
};

const FieldAutocompleteSelect = props => {
  return <Field component={FieldAutocompleteSelectComponent} {...props} />;
};

export default FieldAutocompleteSelect;
